import { createBrowserRouter } from 'react-router-dom'
import RouteErrorBoundary from './components/common/ErrorPages/RouteErrorBoundary'
import Error404 from './components/common/ErrorPages/Error404'
import LandingPageLayout from './pages/landing/LandingPageLayout'
import EcommerceLayout from './pages/ecom/EcommerceLayout'
import Store from './components/ecommerce/store/Store'
import Homepage from './components/ecommerce/home/HomePage'
import TermsPrivacy from './components/landing/TermsPrivacy'
import HeroHeader from './components/landing/HeroHeader'
import Category from './components/landing/categoryCard/Category'
import Details from './components/landing/Details'
import Features from './components/landing/Features'
import ProductDetails from './components/ecommerce/store/Product/ProductDetails'
import ProvidersFilter from './components/ecommerce/search/ProvidersFilter'

const router = createBrowserRouter([
  {
    path: '/',
    element: <LandingPageLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: '',
        element: (
          <>
            <HeroHeader />
            <Category />
            <Details />
            <Features />
          </>
        ),
      },
      {
        path: 'terms',
        element: <TermsPrivacy />,
      },
    ],
  },
  {
    path: '/home',
    element: <EcommerceLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: '',
        element: <Homepage />,
      },
      {
        path: 'searchpage',
        element: <ProvidersFilter />,
      },
      {
        path: 'store/:storeName',
        element: <Store />,
      },
      {
        path: 'store/ProductDetails/:productId',
        element: <ProductDetails />,
      },
    ],
  },
  // Catch-all 404 route
  {
    path: '*',
    element: <Error404 />,
  },
])

export { router }
